export default __webpack_public_path__ + "static/media/nova-wallet-logo.3d4d2ad1.svg";